import React from "react";

function NavLink({ href, children, ...props }) {
  const path = window.location.pathname;
  return (
    <li className={path === href ? "active" : ""}>
      <a href={href} {...props}>
        {children}
      </a>
    </li>
  );
}

export default function NavBar() {
  return (
    <nav
      className="navbar bg-dark border-bottom fixed-top mb-5"
      data-bs-theme="dark"
    >
      <div className="container-fluid">
        <a className="navbar-brand" href="/ReactSite/">
          My React Playground
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarText">
          <ul className="navbar-nav">
            <NavLink href="/ReactSite/">Home</NavLink>
            <NavLink href="/ReactSite/ToDoApp/ToDoApp">ToDo App</NavLink>
            <NavLink href="/ReactSite/BudgetApp/BudgetApp">
              Budget Allowcation App
            </NavLink>
            <NavLink href="https://saltirewebsites.com/ReactShoppingCart/">
              Shopping Cart App
            </NavLink>
            <NavLink href="/ReactSite/ContactPage">Contact Page</NavLink>
          </ul>
          <span className="navbar-text">element</span>
        </div>
      </div>
    </nav>
  );
}
